$(document).ready(function () {
    if ($(".siteCookies").length) {
        $(".siteCookies__links").appendTo(".siteCookies__buttonWrap");
        $(".siteCookies__button.js-cookiesConsentSubmit").html(getShopDataLayer().cookies.acceptButton);
    }
})